import { render, staticRenderFns } from "./AverageTeamBrain.vue?vue&type=template&id=449720e2&scoped=true&"
import script from "./AverageTeamBrain.vue?vue&type=script&lang=js&"
export * from "./AverageTeamBrain.vue?vue&type=script&lang=js&"
import style0 from "./AverageTeamBrain.vue?vue&type=style&index=0&id=449720e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449720e2",
  null
  
)

export default component.exports